export const onRequestError = async (error) => {
    throw error;
};

export const interceptRequest = async (config) => {
  return {
    ...config,
    headers: {
      ...config.headers,
    },
  };
};
